import { AiOutlineTikTok } from 'react-icons/ai';
import { FiFacebook, FiInstagram, FiLinkedin } from 'react-icons/fi';

import { useTheme } from '../../context/ThemeContext';
import OptimizedImage from '../OptimizedImage';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';

  return (
    <footer className="bg-panel dark:bg-panel pt-16 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="mb-4 h-10">
              <OptimizedImage
                src={isDarkMode ? "/logo_light.png" : "/logo_dark.png"}
                alt="Konnect Better Logo"
                objectFit="contain"
              />
            </div>
            <p className="text-theme-secondary mb-4">
              Building better relationships through research-based coaching.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/konnectbetter/" target="_blank" rel="noopener noreferrer" className="text-theme-secondary hover:text-brand-primary dark:hover:text-brand-secondary transition-colors" aria-label="Instagram">
                <FiInstagram size={20} />
              </a>
              <a href="https://www.tiktok.com/@konnect.better" target="_blank" rel="noopener noreferrer" className="text-theme-secondary hover:text-brand-primary dark:hover:text-brand-secondary transition-colors" aria-label="TikTok">
                <AiOutlineTikTok size={20} />
              </a>
              <a href="https://www.facebook.com/konnectbetter/" target="_blank" rel="noopener noreferrer" className="text-theme-secondary hover:text-brand-primary dark:hover:text-brand-secondary transition-colors" aria-label="Facebook">
                <FiFacebook size={20} />
              </a>
              <a href="https://www.linkedin.com/company/konnectbetter/" target="_blank" rel="noopener noreferrer" className="text-theme-secondary hover:text-brand-primary dark:hover:text-brand-secondary transition-colors" aria-label="LinkedIn">
                <FiLinkedin size={20} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold text-primary dark:text-theme-primary mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/#about" className="text-theme-secondary hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="/#app" className="text-theme-secondary hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">
                  Mobile App
                </a>
              </li>
              <li>
                <a href="/#products" className="text-theme-secondary hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">
                  Products
                </a>
              </li>
              <li>
                <a href="/#team" className="text-theme-secondary hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">
                  Our Team
                </a>
              </li>
              <li>
                <a href="/#faq" className="text-theme-secondary hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a href="/wisdom" className="text-theme-secondary hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">
                  Wisdom
                </a>
              </li>
              <li>
                <a href="/joincommunity" className="text-theme-secondary hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-primary dark:text-theme-primary mb-4">Download App</h3>
            <div className="flex flex-col items-center">
              <span className="bg-brand-primary text-white text-[10px] font-semibold px-3 py-1 rounded-full mb-3">
                Coming Soon
              </span>
              <div className="flex flex-col space-y-3 w-full">
                <button
                  type="button"
                  disabled
                  className="flex items-center justify-center space-x-2 px-6 py-3 rounded-lg border border-theme bg-card dark:bg-panel text-theme-primary dark:text-theme-primary shadow-surface opacity-70 cursor-not-allowed w-full"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5646 12.9838C17.5458 10.0786 20.0278 8.60303 20.1382 8.53394C18.6788 6.47992 16.4118 6.19144 15.6003 6.17323C13.7451 5.97852 11.9535 7.27303 11.0105 7.27303C10.0457 7.27303 8.60117 6.19144 7.04354 6.22786C5.01862 6.26428 3.12558 7.43766 2.06447 9.25831C-0.118528 12.9656 1.44239 18.4285 3.52558 21.2701C4.56748 22.6738 5.78006 24.2496 7.37558 24.1905C8.93321 24.1314 9.51319 23.1848 11.3684 23.1848C13.2018 23.1848 13.7451 24.1905 15.3625 24.1496C17.0344 24.1314 18.0763 22.7277 19.0847 21.3058C20.2973 19.6709 20.7861 18.0769 20.8049 17.9996C20.7673 17.9814 17.5864 16.6732 17.5646 12.9838Z" />
                    <path d="M14.6005 4.05241C15.4557 2.98903 16.0357 1.52262 15.8707 0.0380859C14.6005 0.0926955 13.0429 0.892762 12.1513 1.93793C11.3689 2.85517 10.6667 4.36069 10.8499 5.80889C12.2547 5.90619 13.7267 5.09697 14.6005 4.05241Z" />
                  </svg>
                  <div>
                    <p className="text-xs">Download on the</p>
                    <p className="text-sm font-semibold">App Store</p>
                  </div>
                </button>
                <button
                  type="button"
                  disabled
                  className="flex items-center justify-center space-x-2 px-6 py-3 rounded-lg border border-theme bg-card dark:bg-panel text-theme-primary dark:text-theme-primary shadow-surface opacity-70 cursor-not-allowed w-full"
                >
                  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.22183 0.313477C0.988258 0.565283 0.871582 0.908142 0.871582 1.34206V22.6572C0.871582 23.0911 0.988258 23.434 1.22183 23.6858L1.30094 23.7649L13.1048 11.9611V11.8781V11.7951L1.30094 -0.00878906L1.22183 0.313477Z" />
                    <path d="M17.2974 16.1538L13.1047 11.9611V11.8781V11.7951L17.2974 7.60254L17.3765 7.6816L22.3047 10.4358C23.6878 11.2111 23.6878 12.5451 22.3047 13.3204L17.3765 16.0746L17.2974 16.1538Z" />
                    <path d="M17.3766 16.0746L13.1048 11.8781L1.22192 23.6858C1.69305 24.1988 2.47748 24.1988 3.36748 23.7649L17.3766 16.0746Z" />
                    <path d="M17.3766 7.68165L3.36748 -0.00878906C2.47748 -0.442789 1.69305 -0.442789 1.22192 0.0702734L13.1048 11.7951L17.3766 7.68165Z" />
                  </svg>
                  <div>
                    <p className="text-xs">Get it on</p>
                    <p className="text-sm font-semibold">Google Play</p>
                  </div>
                </button>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold text-primary dark:text-theme-primary mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="text-theme-secondary">
                Email: <a href="mailto:info@konnectbetter.com" className="hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">info@konnectbetter.com</a>
              </li>
              <li className="text-theme-secondary">
                Address: <a href="https://maps.google.com/?q=2+St+Clair+Ave+E+%23800,+Toronto+ON+M4T+2T5" target="_blank" rel="noopener noreferrer" className="hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">2 St Clair Ave E #800, Toronto ON M4T 2T5</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-theme pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-theme-secondary text-sm mb-4 md:mb-0">
              © {currentYear} Konnect Better. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="/privacy-policy" className="text-theme-secondary text-sm hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">
                Privacy Policy
              </a>
              <a href="/terms-of-service" className="text-theme-secondary text-sm hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">
                Terms of Service
              </a>
              <a href="/refund-policy" className="text-theme-secondary text-sm hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">
                Refund Policy
              </a>
              <a href="#" className="text-theme-secondary text-sm hover:text-brand-primary dark:hover:text-brand-secondary transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
